export default __webpack_public_path__ + "static/media/guesty_step7.70f9ab21.png";